export const themeColors = {
  main: "#1677ff", // aqua-ish
};

export const backgroundMain = {
  background: themeColors["main"],
};
